export { default } from './UnscoredTableItemCard'
